module.exports = __webpack_public_path__ + "static/Tarrasque-d5d061f5d205adcb236811c1a6732ed5.jpg";